import React from 'react';
import { Radio } from 'js/components/common/Fields/Radio';

import { NO_DURATION } from '../../constants';

import style from './Duration.scss';

export const Duration = ({ translate, availablePeriods }) => availablePeriods.length
    ? (
        <div className={style.duration}>
            <p className={style.subTitle}>{translate('duration.title')}</p>
            {[...availablePeriods, NO_DURATION].map(duration => (
                <Radio
                    wrapText
                    key={duration}
                    name="duration"
                    value={duration}
                    label={translate(`duration.${duration}`)}
                    aria-label={translate([`duration.${duration}`, 'playtech.mobile.system.radio.aria-label'])}
                />
            ))}
        </div>
    )
    : null;
